import { championContenders, championTracks, weekTrend } from "@/mocks/homeData";

export default function ChampionSection() {
  return (
    <section id="arena-top" className="bg-secondary-100/70">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-semibold text-accent-900">
            <i className="ri-medal-2-line text-sm"></i>
            本周全民票选 · 吃瓜王争霸已开战
          </span>
          <h3 className="mt-5 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            谁将登顶吃瓜王冠军？
          </h3>
          <p className="mt-4 text-sm leading-6 text-foreground-600 md:text-base">
            每天都有新瓜登场，但只有热度与声量双料领跑、又拿下全民票选的那一个，
            才能捧走「吃瓜王第一名」的称号。
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          {/* champion podium + contender list */}
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <div className="flex items-center gap-4">
              <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-accent-500 text-background-50">
                <i className="fa-solid fa-crown text-2xl"></i>
              </span>
              <div className="min-w-0">
                <p className="text-xs font-semibold text-accent-700">暂列吃瓜王第一名</p>
                <h4 className="mt-1 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
                  「收官夜爆灯求婚」名场面
                </h4>
              </div>
              <span className="ml-auto shrink-0 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                冠军领跑
              </span>
            </div>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {championTracks.map((t) => (
                <div key={t.label} className="rounded-xl bg-secondary-100/70 px-3 py-4 text-center">
                  <p className="font-num text-2xl text-foreground-950 md:text-3xl">{t.value}</p>
                  <p className="mt-1 text-[11px] text-foreground-500">{t.label}</p>
                </div>
              ))}
            </div>

            <p className="mt-6 text-xs font-medium text-foreground-500">本周挑战者 · 实时票数（万）</p>
            <ul className="mt-3 space-y-3">
              {championContenders.map((c) => (
                <li key={c.id} className="flex items-center gap-3">
                  <span className="w-4 shrink-0 font-num text-sm text-foreground-400">{c.id}</span>
                  <span className="w-24 shrink-0 truncate text-sm font-medium text-foreground-800 md:w-32">
                    {c.name}
                  </span>
                  <div className="h-2 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${
                        c.isChampion ? "bg-gradient-to-r from-accent-400 to-accent-500" : "bg-secondary-400"
                      }`}
                      style={{ width: `${(c.vote / 482) * 100}%` }}
                    ></div>
                  </div>
                  <span className="font-num text-sm text-foreground-700">{c.vote}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* week trend timeline */}
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <div className="flex items-center justify-between">
              <h4 className="font-heading text-base font-bold text-foreground-950">本周瓜势走向</h4>
              <span className="text-xs text-foreground-400">热度曲线</span>
            </div>
            <ol className="mt-6 space-y-0">
              {weekTrend.map((d, i) => (
                <li key={d.day} className="relative flex gap-4 pb-5 last:pb-0">
                  {i < weekTrend.length - 1 && (
                    <span className="absolute left-[15px] top-7 h-full w-px bg-background-200"></span>
                  )}
                  <span
                    className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-[10px] font-semibold ${
                      i === 6
                        ? "border-accent-500 bg-accent-500 text-background-50"
                        : "border-background-300 bg-background-50 text-foreground-600"
                    }`}
                  >
                    {d.day.replace("周", "")}
                  </span>
                  <div className="min-w-0 flex-1 pt-1">
                    <div className="flex items-center justify-between">
                      <p className="truncate text-sm font-medium text-foreground-800">{d.topic}</p>
                      <span className={`ml-3 font-num text-sm ${i === 6 ? "text-accent-700" : "text-foreground-400"}`}>
                        {d.heat}
                      </span>
                    </div>
                    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${
                          i === 6 ? "bg-accent-500" : "bg-secondary-300"
                        } animate-riseBar`}
                        style={{ width: `${d.heat}%` }}
                      ></div>
                    </div>
                  </div>
                </li>
              ))}
            </ol>

            <a
              href="#download"
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
            >
              投出你的一票
              <i className="ri-checkbox-circle-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}